import api from ".";

export const getCurrentUser = async () => api.get("/users/me");
export const create = async user => api.post("/users", user);

export default {
  getCurrentUser,
  create,
};
